/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const AlertIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M12 2C7.976 2 4.714 5.358 4.714 9.5v4.482l-.858.884a1.28 1.28 0 0 0-.264 1.362c.188.467.631.772 1.122.772h14.572c.49 0 .934-.305 1.121-.772a1.28 1.28 0 0 0-.263-1.362l-.858-.884V9.5C19.286 5.358 16.024 2 12 2M12 22c-2.012 0-3.643-1.679-3.643-3.75h7.286c0 2.071-1.631 3.75-3.643 3.75" /></svg>;
};
export default AlertIcon;